let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4fCJZ"), load("aZinD"), load("3JWH2"), load("hvHZS"), load("bupWa")]).then(() => parcelRequire('bEmzp'));